export default __webpack_public_path__ + "static/media/ill-9.fbc34d32.svg";